import React from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import { GET_SUBSCRIPTIONS } from 'graphql/products';
import Alert from '@material-ui/lab/Alert';
import Spin from 'components/common/Spin';
import SubscriptionDetails from './SubscriptionDetails';

const Subscription = ({ student }) => {
  return (
    <>
      <Helmet title="Subscription" />
      <Query
        query={GET_SUBSCRIPTIONS}
        variables={{ studentId: student.id }}
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, error, refetch }) => {
          if (loading) return <Spin spinning linear />;
          if (error) {
            return <Alert severity="error">{error.message}</Alert>;
          }
          const sub = data.subscriptions[0];
          if (!sub) return (
            <Alert severity="error">No subscription found. Please contact us for help.</Alert>
          );
          return <SubscriptionDetails student={student} subscription={sub} />;
        }}
      </Query>
    </>
  );
};

export default Subscription;
